// Simple Main Product Image Carousel
document.addEventListener('DOMContentLoaded', function() {
    const mainImage = document.querySelector('.main-product-image');
    const mobileThumbnails = document.querySelectorAll('.mobile-thumbnail-image');
    const desktopThumbnails = document.querySelectorAll('.thumbnail-image');
    
    if (!mainImage || mobileThumbnails.length === 0) return;

    let currentImageIndex = 0;
    const allImages = Array.from(mobileThumbnails);
    let touchStartX = 0;
    let touchEndX = 0;
    let isDragging = false;
    let isAnimating = false;

    // No animation for thumbnail clicks - instant change
    function updateMainImage(fullImageSrc) {
        if (mainImage && !isAnimating && mainImage.src !== fullImageSrc) {
            isAnimating = true;
            mainImage.src = fullImageSrc;
            setTimeout(() => {
                isAnimating = false;
            }, 50);
        }
    }

    // Quick fade animation for swipe navigation
    function updateMainImageWithSlide(fullImageSrc, direction = 'right') {
        if (mainImage && !isAnimating && mainImage.src !== fullImageSrc) {
            isAnimating = true;
            
            // Quick fade out
            mainImage.style.transition = 'opacity 0.15s ease-out';
            mainImage.style.opacity = '0';
            
            // Change image and fade in
            setTimeout(() => {
                mainImage.src = fullImageSrc;
                mainImage.style.transition = 'opacity 0.2s ease-in';
                mainImage.style.opacity = '1';
                
                setTimeout(() => {
                    mainImage.style.transition = '';
                    isAnimating = false;
                }, 200);
            }, 150);
        }
    }

    // Update selected state
    function updateSelectedState(clickedThumbnail) {
        mobileThumbnails.forEach(thumb => thumb.classList.remove('selected'));
        desktopThumbnails.forEach(thumb => thumb.classList.remove('selected'));
        clickedThumbnail.classList.add('selected');
    }

    // Update main image from index (fade for thumbnails)
    function updateMainImageFromIndex(index) {
        if (allImages[index] && !isAnimating) {
            const fullImageSrc = allImages[index].getAttribute('data-full-image');
            if (fullImageSrc) {
                updateMainImage(fullImageSrc);
                updateSelectedState(allImages[index]);
            }
        }
    }

    // Update main image from index with slide (for swipes)
    function updateMainImageFromIndexWithSlide(index, direction) {
        if (allImages[index] && !isAnimating) {
            const fullImageSrc = allImages[index].getAttribute('data-full-image');
            if (fullImageSrc) {
                updateMainImageWithSlide(fullImageSrc, direction);
                updateSelectedState(allImages[index]);
            }
        }
    }

    // Navigate to next image (with slide animation)
    function goToNextImage() {
        if (currentImageIndex < allImages.length - 1 && !isAnimating) {
            currentImageIndex++;
            updateMainImageFromIndexWithSlide(currentImageIndex, 'right');
        }
    }

    // Navigate to previous image (with slide animation)
    function goToPreviousImage() {
        if (currentImageIndex > 0 && !isAnimating) {
            currentImageIndex--;
            updateMainImageFromIndexWithSlide(currentImageIndex, 'left');
        }
    }

    // Touch handlers for swipe navigation
    function handleMainImageTouchStart(e) {
        if (isAnimating) return;
        touchStartX = e.touches[0].clientX;
        isDragging = true;
    }

    function handleMainImageTouchMove(e) {
        if (!isDragging || isAnimating) return;
        const touchMoveX = e.touches[0].clientX;
        const deltaX = Math.abs(touchStartX - touchMoveX);
        if (deltaX > 10) e.preventDefault();
    }

    function handleMainImageTouchEnd(e) {
        if (!isDragging || isAnimating) return;
        touchEndX = e.changedTouches[0].clientX;
        isDragging = false;
        
        const deltaX = touchStartX - touchEndX;
        if (Math.abs(deltaX) > 50) {
            deltaX > 0 ? goToNextImage() : goToPreviousImage();
        }
    }

    // Update current index when thumbnails are clicked
    function updateCurrentIndex(clickedThumbnail) {
        const index = allImages.indexOf(clickedThumbnail);
        if (index !== -1 && index !== currentImageIndex && !isAnimating) {
            currentImageIndex = index;
            updateMainImageFromIndex(currentImageIndex);
        }
    }

    // Add touch event listeners
    if (mainImage) {
        mainImage.addEventListener('touchstart', handleMainImageTouchStart, { passive: false });
        mainImage.addEventListener('touchmove', handleMainImageTouchMove, { passive: false });
        mainImage.addEventListener('touchend', handleMainImageTouchEnd, { passive: false });
    }

    // Add click handlers for thumbnails
    mobileThumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function() {
            updateCurrentIndex(this);
        });
    });

    desktopThumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function() {
            updateCurrentIndex(this);
        });
    });

    // Initialize
    if (allImages.length > 0) {
        updateMainImageFromIndex(0);
    }
});
